import { getGtmData, GtmCustomData, recordEventWrapper } from '..';
import { EXPLORE_SCHEMES_USER_FLOW, HOME, LANDING_SCREEN } from '../../constants/ExplorePage';
import { getPageNameForSchemeListGTM, getPageTitleForSchemePageLoadListGTM, SchemeListDataGTM, getTitleAndLabelOnAxisSelectToggleGTM, getLabelForInvestClickGTM, getPageTitleForDurationSelectGTM, getTitleForTransactionSuccess } from '../utils';

const explore = () => ({
  explorePageLoad: () => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: 'vpv/pfm/mutual-funds/funds-nfos',
      title: 'PFM - Mutual Funds - Funds & NFOs',
      cd24: getGtmData('cd24') // <<pass platform either website or internet-banking or mobile-app>>
    });
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: 'PFM',
      action: 'Pageload',
      label: 'mutual funds | funds category'
    })
  }, 

  //1557
  // eventType could be Back, Equity Funds, Debt Funds, and so on..
  exploreEvent: (eventType: string, userFlow?: string) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow == EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS ? 'investment ideas' : 'funds category'}`,
      label: `${eventType}`,
    })
  },

  // Note: Not to handled logout click as of now
  // exploreLogOutClick: () => {
  //   recordEventWrapper({
  //     event: 'event_PFM_on_click_vpv',
  //     page: 'vpv/pfm/online-investments/explore-mutual-funds',
  //     title: 'PFM - Online Investments - Explore Mutual Funds'
  //   });
  //   recordEventWrapper({
  //     event: 'event_PFM_on_click_event',
  //     category: 'PFM',
  //     action: 'Online Investments',
  //     label: 'Explore Mutual Funds - Logout'
  //   })
  // },

  // Scheme List Page
  // Action Type could be either Home or Landing Screen used only for Inv ideas and save tax page
  // schemeListPageLoad: (userFlow: string, fundCategory?: string, fundSubCategory?: string, actionType?: string) => {
    schemeListPageLoad: (userFlow: string, data: SchemeListDataGTM, gtmData?: GtmCustomData) => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: `vpv/pfm/mutual-funds/${getPageNameForSchemeListGTM(userFlow, { actionType: HOME ,...data})}`,
      title: `PFM - Mutual Funds - ${getPageTitleForSchemePageLoadListGTM(userFlow, {actionType: HOME ,...data})}`,
      ...gtmData
    }),
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: 'PFM',
      action: 'Pageload',
      label: `mutual funds | ${getPageTitleForSchemePageLoadListGTM(userFlow, {actionType: LANDING_SCREEN ,...data})}`
    })
  },

    // Back Click
    onBackClick: (userFlow: string, data: SchemeListDataGTM) => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: 'mutual funds | funds category',
        label: `Back`
      })
    },

    onSchemeSelectionOnFilter: (userFlow: string, data: SchemeListDataGTM, subCategorySelected?) => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | ${getPageTitleForSchemePageLoadListGTM(userFlow, {actionType: LANDING_SCREEN ,...data})}`,
        label: `Type of fund | ${subCategorySelected}`
      })
    },

    //1557
    onSchemeDurationSelect: (duration: string, userFlow, fundCategory?, subCategory?) => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | ${getPageTitleForDurationSelectGTM(userFlow, fundCategory, subCategory)}`,
        label: `return duration - ${duration}`
      })
    },

    // Axis Select Toggle Click
    onAxisSelectToggle: (userFlow: string, data: SchemeListDataGTM) => {
      // recordEventWrapper({
      //   event: 'event_PFM_on_click_vpv',
      //   page: `vpv/pfm/online-investments/explore-mutual-funds/${getPageNameAxisSelectToggleGTM(userFlow, data)}/axis-select`,
      //   title: `PFM - Online Investments - Explore Mutual Funds - ${getTitleAndLabelOnAxisSelectToggleGTM(userFlow, data)} - Axis Select`
      // }),
      
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds |  ${getTitleAndLabelOnAxisSelectToggleGTM(userFlow, data)}`,
        label: `Show only Axis Bank Select`
      })
    },

    //1557
    // Invest Button click event
    onInvestClickGTM: (userFlow: string, data: SchemeListDataGTM) => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | ${getPageTitleForSchemePageLoadListGTM(userFlow, {actionType: LANDING_SCREEN ,...data})}`,
        label: `Invest | ${getLabelForInvestClickGTM(userFlow, data)} | ${getGtmData('cd67')}`,
        cd66: getGtmData('cd66'),
        cd67: getGtmData('cd67')
      })
    },

    //1557
    onEditRiskProfileClickGTM: () => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | funds category`,
        label: `risk profile | edit`,
      })
    },

  //1557
    onInvestBasisGoalsClickGTM: (userFlow: string, fundType: string) => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | ${fundType?.toLowerCase()} Funds`,
        label: `invest basis your goals`
      })
    },

    // 3. Scheme Details page
    schemeDetailPageLoad: (scheme: string) => {
      // recordEventWrapper({
      //   event: 'event_PFM_on_page_load_vpv',
      //   page: `vpv/pfm/online-investments/explore-mutual-funds/${scheme}/scheme-details`,
      //   title: `PFM - Online Investments - Explore Mutual Funds - ${scheme} - Scheme Details`
      // }),
      // recordEventWrapper({
      //   event: 'event_PFM_on_page_load_event',
      //   category: 'PFM',
      //   action: 'Online Investments',
      //   label: `Explore Mutual Funds - ${scheme} - Scheme Details`
      // })
    },

    // actionType could be either Back or Click Here
    schemeListActionClick: (scheme: string, actionType: string) => {
      // recordEventWrapper({
      //   event: 'event_PFM_on_page_click_event',
      //   category: 'PFM',
      //   action: 'Online Investments',
      //   label: `Explore Mutual Funds - ${scheme} - Scheme Details - ${actionType}`
      // })
    },

    // data will have cd66 and cd68 as values.
    schemeListInvestClick: (scheme: string, data: GtmCustomData, userFlow? : string) => {
      recordEventWrapper({
        event: 'event_pfm_onload_vpv',
        page: `/vpv/pfm/mutual-funds/${userFlow?.toLowerCase()}`,
        title: `PFM - Mutual Funds - ${userFlow?.toLowerCase()} - ${scheme}`
      }),
      recordEventWrapper({
        event: 'event_pfm_onload',
        category: 'PFM',
        action: 'Pageload',
        label: `mutual funds | ${userFlow?.toLowerCase()} | ${scheme}`,
        ...data
      }),
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | ${userFlow?.toLowerCase()} | ${scheme}`,
        label: `invest now`
      })
    },

    // 4. Invest page
    investPageLoad: (scheme: string) => {
      // recordEventWrapper({
      //   event: 'event_PFM_on_page_load_vpv',
      //   page: `vpv/pfm/online-investments/explore-mutual-funds/${replaceEmptySpaceWithHyphen(scheme, true)}/home`,
      //   title: `PFM - Online Investments - Explore Mutual Funds - ${scheme} - Home`
      // }),
      // recordEventWrapper({
      //   event: 'event_PFM_on_page_load_event',
      //   category: 'PFM',
      //   action: 'Online Investments',
      //   label: `Explore Mutual Funds - ${scheme} - Landing Screen`
      // })
    },

    // actionType can be Back, Terms and Conditions, Continue, Add Nominee, Edit Nominee.
    investPageActionClick: (scheme: string, actionType: string, userFlow?) => {
    const flow = userFlow ? userFlow.toLowerCase() : 'unknown';
       recordEventWrapper({
         event: 'event_pfm',
         category: 'PFM',
         action: `mutual funds | ${flow} | ${scheme}`,
         label: `${actionType}`
       });
    },

    // Data will have cd68, cd69, cd70 and cd74
    investPageContinueClick: (scheme: string, data: GtmCustomData, userFlow?, isLumpsum?) => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | ${userFlow?.toLowerCase()} | ${scheme}`,
        label: `continue | ${isLumpsum ? "Lumpsum" : "SIP"}`,
        ...data
      })
    },

    // 5. Nominee Modal
    nomineeModalPageLoad: (scheme: string) => {
      // recordEventWrapper({
      //   event: 'event_PFM_on_page_load_vpv',
      //   page: `vpv/pfm/online-investments/explore-mutual-funds/${replaceEmptySpaceWithHyphen(scheme, true)}/home/add-nominee`,
      //   title: `PFM - Online Investments - Explore Mutual Funds - ${scheme} - Home - Add Nominee`
      // }),
      // recordEventWrapper({
      //   event: 'event_PFM_on_page_load_event',
      //   category: 'PFM',
      //   action: 'Online Investments',
      //   label: `Explore Mutual Funds - ${scheme} - Landing Screen - Add Nominee`
      // })
    },

    // actionType can be Close, Remove, Add Another Nominee, Confirm Nominee
    nomineeModalActionClick: (scheme: string, actionType: string) => {
      // recordEventWrapper({
      //   event: 'event_PFM_on_click_event',
      //   category: 'PFM',
      //   action: 'Online Investments',
      //   label: `Explore Mutual Funds - ${scheme} - Landing Screen - Add Nominee - ${actionType}`
      // })
    },

    // 7. OTP Modal
    otpModalPageLoad: (scheme: string, userFlow?) => {
      recordEventWrapper({
        event: 'event_pfm_onload_vpv',
        page: `/vpv/pfm/mutual-funds/${userFlow?.toLowerCase()}/otp-verification`,
        title: `PFM - Mutual Funds - ${userFlow?.toLowerCase()} - OTP Verification`
      }),
      recordEventWrapper({
        event: 'event_pfm_onload',
        category: 'PFM',
        action: 'Pageload',
        label: `mutual funds | ${userFlow?.toLowerCase()} - - otp verification`
      })
    },

    // actionType can be either Close or Submit
    otpModalActionClick: (scheme: string, actionType: string, userFlow?) => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | ${userFlow?.toLowerCase()} - otp verification`,
        label: `success | ${scheme}`
      })
    },

    // 8. Successful transaction page
    // data will have cd71 value
    successPageLoad: (scheme: string, data: GtmCustomData) => {
      recordEventWrapper({
        event: 'event_pfm_onload_vpv',
        page: `/vpv/pfm/mutual-funds/save-tax/congratulations/${scheme}`,
        title: `PFM - Mutual Funds - Save Tax - Congratulations - ${scheme}`,
        ...data
      }),
      recordEventWrapper({
        event: 'event_pfm_onload',
        category: 'PFM',
        action: 'Pageload',
        label: `mutual funds | congratulations | ${scheme}`
      })
    },

    successPageGoBackTextClick: (scheme: string, goBackMessage: string) => {
      // recordEventWrapper({
      //   event: 'event_PFM_on_click_event',
      //   category: 'PFM',
      //   action: 'Online Investments',
      //   label: `Explore Mutual Funds - ${scheme} - Investment Successful - ${goBackMessage}`
      // })
    },

    // actionButton will have the value of the button i.e "Every Goal Deserves a SIP. Start one more SIP", "Start a SIP in International Funds", etc.
    // NOTE: This event is common for all the flows except Invest basis risk profile i.e Explore, Plan goals with SIP, Inv ideas, save tax, invest more, switch, redeem 
    successPageActionButtonsClick: (userFlow: string, scheme: string, actionButton: string) => {
      recordEventWrapper({
        event: 'event_pfm',
        category: 'PFM',
        action: `mutual funds | ${getTitleForTransactionSuccess(userFlow)} - congratulations | ${scheme}`,
        label: `${actionButton}`
      })
    }
});

export default explore;
